import { Cross2Icon } from "@radix-ui/react-icons";
import { Toggle } from "../../../../../../shared/components/toggle/Toggle";
import { useTranslation } from "react-i18next";

const ActionsPerformanceDataExplorerFilterField = ({
  field: { type, label, value },
  onFieldClick,
}) => {
  const { t } = useTranslation();
  const handleOnFieldClick = () => {
    onFieldClick({ type, value });
  };

  return (
    <Toggle
      key={value}
      size="sm"
      variant="outline"
      value={label}
      onClick={handleOnFieldClick}
      className="m-1 bg-accent text-accent-foreground"
    >
      {t(label)}
      &nbsp;&nbsp;
      <Cross2Icon onClick={handleOnFieldClick} />
    </Toggle>
  );
};

export default ActionsPerformanceDataExplorerFilterField;
